<template>
	<div class="chart-item chart-item--h70">
		<div class="charts__title charts-title">
			<div class="charts-title__elem text-uppercase">Гистограмма дохода</div>
			<div class="charts-title__elem charts-title__elem--right">
				<router-link :to="{name: 'chart' , query: { chart: 'gistogramm' }}" target="_blank">
					<i v-show="!fullStatus && !mini" class="icon-fullscreen"></i>
				</router-link>
			</div>

		</div>

		<div class="chart__info">
			<div class="chart-info">
				<div class="chart-info__eft">
					<div class="chart-info__row">
						<div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">МАКСИМАЛЬНЫЙ</div>
						<div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
							<watcher :data="getMaxProfit"
									 :units="'%'"
									 :side="'left'"
							>
							</watcher>
						</div>
					</div>
					<div class="chart-info__row">
						<div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">МИНИМАЛЬНЫЙ</div>
						<div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
							<watcher :data="getMinProfit"
									 :units="'%'"
									 :side="'left'"
							>
							</watcher>
						</div>
					</div>
					<div class="chart-info__row">
						<div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">СРЕДНИЙ</div>
						<div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
							<watcher :data="getAverageProfit"
									 :units="'q'"
									 :side="'left'"
							>
							</watcher>
						</div>
					</div>
					<div class="chart-info__row">
						<div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">ТЕКУЩИЙ</div>
						<div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
							<watcher :data="getCurrencyProfit"
									 :units="'%'"
									 :side="'left'"
							>
							</watcher>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="echarts chart-item__echarts" v-if="show">
			<IEcharts style=""
					  :option="bar"
					  :loading="loading"
					  :resizable="resize"
			/>
		</div>
	</div>


</template>
<script>
import Vue from 'vue';
import { mapGetters } from "vuex";
import IEcharts from "vue-echarts-v3/src/full.js";
import ProfitString from './sig-profit-string'
import DataWatcher from '../ui-components/ui-data-watcher'
export default {
    components : {
        'string':ProfitString,
        IEcharts,
        'watcher':DataWatcher
    },
    props: {
        update:{default:true},
        updateHight:{default:true},
        updateRight:{default:true},
        fullStatus:{default:false},
        mini:{default:false}
    },
    data() {
        return {
            stat: [],
            show:true,
            symbol:'',
            loading:false,
            resize:true,
            bar: {
                grid:{
                    height:'87%',
                    width: "95%",
                    right:'54px',
                    top:'0'
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    axisPointer: {
                    type: "cross",
                    axis: "auto"
                    }
                },
                xAxis: {
                    type: 'category',
                    scale:true,
                    axisLine:{
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisTick: {
                        show: true,
                        alignWithLabel: true,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisPointer: {
                        show:true,
                        type: 'shadow',
                    },
                    axisLabel: {
                        align: 'left',
                        color: '#718da8',
                        rotate:'-90'
                    },
                    splitLine: {
                        show:true,
                        interval:0,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    scale:true,
                    interval:5,
                    //max:150,
                    //boundaryGap: true,
                    max:50,
                    position:'right',
                    splitLine: {
                        show:false
                    },
                    //scale:true,
                    axisLine: {
                        show:true,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisTick: {
                        inside: false,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisLabel: {
                        inside: false,
                        align: 'left',
                        verticalAlign:'middle',
                        margin:'8',
                        color:'#718da8',
                        formatter:'{value} %'
                    }
                },
                series: [
                    {
                        name:'Profit on month',
                        data: [],
                        type: 'bar',
                        symbolSize: 5,
                        boundaryGap:true,
                        itemStyle: {
                            normal: {
                                borderWidth: 3,
                                borderColor: '#00ffd0',
                                color: '#00ffd0'
                            }
                        },
                        label: {
                            position: 'top',
                            show:true
                        }
                    },
                    {
                        name:'Averrage profit',
                        data: [],
                        type: 'line',
                        smooth:true,
                        color: "#ecff24",
                        showSymbol:true,
                        boundaryGap:false,
                        lineStyle: {
                            width: 1,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                        areaStyle: {
                                color: {
                                    type: "linear",
                                    x: 0,
                                    y: 0,
                                    x2: 1,
                                    y2: 1,
                                    colorStops: [
                                    {
                                        offset: 0,
                                        color: "rgba(139, 147, 33,0.2)" // color at 0% position
                                    },
                                    {
                                        offset: 1,
                                        color: "rgba(218, 236, 81, 0.1)" // color at 100% position
                                    }
                                    ],
                                    globalCoord: false
                                }
                            },
                        markPoint: {
                            data:[]
                        }
                    }
                ]
            },
            dataProfit:0,

        }
    },
    computed : {
        ...mapGetters({
            getProfit:'accountstat/getMonthProfitStrategy'
        }),
        getMaxProfit() {
            return this.dataProfit.maxProfit;
        },
        getMinProfit() {
            return this.dataProfit.minProfit;
        },
        getCurrencyProfit() {
            return this.dataProfit.clearArray[this.dataProfit.clearArray.length - 1];
        },
        getAverageProfit() {
            return this.dataProfit.pointLine[this.dataProfit.pointLine.length - 1];
        }
    },
    methods : {
         updateChart() {
            let stat = this.getProfit('');
            if (!stat) {
                return;
            }
            this.dataProfit = getPoints(stat, this.bar);
        }
    },
    watch: {
        update: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateHight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateRight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        }
    },
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
                let stat = this.getProfit(this.symbol);
                 this.stat = stat
                  this.updateChart()
                  //this.loading = false;
        });
         this.updateChart()
    }
}

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "statistic-profit-gistagramm",
            handler: handler
        }
    });
}
function sumTo(n, array) {
  let sum = 0;
  for (let i = 0; i <= n; i++) {
    sum += array[i].profit;
  }
  return sum;
}
function getPoints(stats, chartObject) {
    let month = {
        '0':"Январь",
        '1':'Февраль',
        '2':'Март',
        '3':'Апрель',
        '4':'Май',
        '5':'Июнь',
        '6':'Июль',
        '7':'Август',
        '8':'Сентябрь',
        '9':'Октябрь',
        '10':'Ноябрь',
        '11':'Декабрь'
    }
     let point = {
         pointsX: [],
         pointsY: [],
         pointLine:[],
         pointsYNegative: [],
         maxProfit:0,
         minProfit:0,
         clearArray:[]
     }
     let labelRight = {
        normal: {
            position: 'bottom',
            color:'#ff9292'
        }
    }

    let itemStyle = {
        normal: {
            borderWidth: 0,
            borderColor: '#ff9292',
            color: '#ff9292'
        }
    }
    for (let i = 0; i < stats.length; i++) {
         let month = ('0' + (stats[i].month + 1)).slice(-2)
         point.pointsX.push(`${month}.${stats[i].year}`)
            if (Math.ceil(stats[i].profit < 0)) {
                 point.pointsY.push({value:stats[i].profit.toFixed(2),label: labelRight, itemStyle:itemStyle})
            }
            else {
                point.pointsY.push({value:stats[i].profit.toFixed(2),label: '', itemStyle:''})
            }
        point.clearArray.push(stats[i].profit);
        point.pointLine.push((sumTo(i,stats) / (i + 1)).toFixed(2))
     }
     point.maxProfit = Math.max(...point.clearArray);
     point.minProfit = Math.min(...point.clearArray);
     chartObject.xAxis.data = point.pointsX;
     chartObject.series[0].data = point.pointsY;
     chartObject.series[1].data = point.pointLine;
     chartObject.series[1].markPoint.data = [];
     chartObject.series[1].markPoint.data.push(
         {
            xAxis:point.pointsX[point.pointsX.length - 1],
            yAxis:point.pointLine[point.pointLine.length - 1],
            value:point.pointLine[point.pointLine.length - 1] + '%',
            silent: true,
            symbol:'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z',
            symbolSize: [68, 19],
            symbolRotate: '0',
            symbolKeepAspect: false,
            symbolOffset: ['50%', '0'],
            label: {
                show:true,
                color:'#ecff24',
                position: ['25%', '20%'],
            }
        }
     )
     chartObject.yAxis.max = point.maxProfit + point.maxProfit*0.3;
     return point;
}
</script>
<style lang="less" scoped>
.echarts {
    min-width: 100%;
    background: #3d536b;
}

.charts__title {

    a {
        margin-right: 20px;
        font-size: 20px;
        color:#adc4e1;
    }
}

.chart__inf {
    &-section {
        display: flex;
        align-items: baseline;
        &-right {
            margin-left: 12px;
            width: 100px;
        }
    }
    &-wrapper {
        display: flex;
        margin-bottom: 0;
    }
    &-item__title {
        font-family: Arimo;
        font-size: 12px;
        font-weight: 700;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: .4px;
        color: #aabed2;
        text-transform: uppercase;
        margin-right: 12px;
        &-full {
            font-size: 23px;
            line-height: 1;
            margin-bottom: 12px;
        }

        @media (max-width:1680px) {
            font-size: 10px;
        }
        @media (max-width:1400px) {
            font-size: 8px;
        }
    }
    &-item__data {
        font-family: Arimo;
        //font-size: 13px;
        font-style: normal;
        font-weight: 700;
        font-stretch: normal;
        line-height: 1.27;
        letter-spacing: .4px;
        //max-height: 16px;
        color:#fff;
         &-full {
            font-size: 23px;
            line-height: 1;
            margin-bottom: 12px;
        }
        @media (max-width:1650px) {
            font-size: 12px;
        }
    }
}

.echarts-full {
    height: calc(100vh - 225px);
}
@media screen and (min-width: 2240px) {
      .echarts  {
     // height: 828px;
      }
  }
</style>

